import React from 'react';
import { useToggle } from 'react-use';
import toString from 'lodash/toString';
import split from 'lodash/split';
import { TimePicker } from 'antd';
import moment from 'moment';
import cn from 'classnames';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useClickAway } from '@umijs/hooks';

function PlaylistDuration({ duration, readOnly, onChange: handleChange }) {
  const [isEdited, toggleEdited] = useToggle(false);

  const ref = useClickAway(() => {
    toggleEdited(false);
  });

  let hours = toString(Math.trunc(duration / 60));
  let minutes = toString(duration % 60);
  hours = hours.length < 2 ? `0${hours}` : hours;
  minutes = minutes.length < 2 ? `0${minutes}` : minutes;
  duration = `${hours}:${minutes}`;

  const onClick = () => {
    if (readOnly) return;
    if (!isEdited) toggleEdited();
  };
  const onChange = (value) => {
    const time = value.format('mm:ss');

    const [from, to] = split(time, ':');
    const duration = parseInt(from) * 60 + parseInt(to);
    handleChange(duration);
    toggleEdited();
  };
  const onOpenChange = (open) => {
    toggleEdited(open);
  };
  const value = moment(duration, 'mm:ss');

  return (
    <div
      ref={ref}
      className={cn('playlist-card__duration', {
        'playlist-card__duration--read-only': readOnly,
      })}
      onClick={onClick}
    >
      <ClockCircleOutlined />
      {isEdited ? (
        <TimePicker
          defaultValue={value}
          popupClassName="playlist-card__duration-popup"
          className="playlist-card__duration-control"
          autoFocus={true}
          onBlur={toggleEdited}
          suffixIcon={null}
          clearIcon={null}
          open={isEdited}
          onOpenChange={onOpenChange}
          onChange={onChange}
          format="mm:ss"
          getPopupContainer={(trigger) => trigger.parentNode}
        />
      ) : (
        <span>{duration}</span>
      )}
    </div>
  );
}

export default PlaylistDuration;
